import { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./App.css";
import LoadingPage from "./components/LoadingPage";

import PublicRoutes from "./routes/PublicRoutes"; // Ya maneja las rutas públicas
import PrivateRoutes from "./routes/PrivateRoutes"; // Ya maneja las rutas privadas
import { CookieConsent } from "@/components/cookie-consent.jsx";
import Home from "@/pages/start/Home";
//import ChatPage from "@/pages/chat/ChatPage";

import Header from "@/components/start/Header";
import PricingPage from "./pages/start/plansPage";

import { GoogleAuthProvider } from "@/context/GoogleAuthContext.js";


const clientId = "262070749684-nt66f8pap863o9hog2t6g5fctkchjlli.apps.googleusercontent.com";
//hola para hacer un commit 
function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <GoogleOAuthProvider clientId={clientId}>

      <GoogleAuthProvider>
        <Router>
          <AnimatePresence>
            {isLoading ? (
              <LoadingPage key="loading" />
            ) : (
              <>
                <Routes>
                  {/* Ruta privada */}
                  <Route path="/*" element={<PrivateRoutes />} />
                </Routes>
                <Header />
                <Routes>
                  {/* Rutas públicas */}
                  <Route path="/" element={<Home />} />
                  {/* <Route path="/chat" element={<ChatView />} /> */}
                  <Route path="/*" element={<PublicRoutes />} />

                  {/* Rutas temporales */}
                  <Route path="/planes" element={<PricingPage />} />
                </Routes>
                <CookieConsent />
              </>
            )}
          </AnimatePresence>
        </Router>
      </GoogleAuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;